import useAuth from '@modules/AuthModule/hooks/useAuth';
import { RequiredType } from './RequirePermissions';
import hasPermissions from './hasPermissions';
import { useMemo } from 'react';

const usePermissions = (
  permissions: string[],
  permissionsType: RequiredType,
) => {
  const { user } = useAuth();

  const hasRequiredPermissions = useMemo(() => {
    return (
      user?.permissions &&
      user?.permissions.length > 0 &&
      hasPermissions(user.permissions, permissions, permissionsType)
    );
  }, [permissions, permissionsType, user?.permissions]);

  return hasRequiredPermissions;
};

export default usePermissions;
